import { ModalUsageContext, ModalUsageContextProps } from 'common/contexts/ModalUsageContext';
import { useContext } from 'react';

const useModal = (): ModalUsageContextProps => useContext(ModalUsageContext);

export default useModal;
